import actions from './actions';

const state = {};
const store = {
  namespaced: true,
  state,
  actions,
};

export default store;
